import React, { createContext, useContext, useEffect, useState } from "react";
import { getSettings, runtime } from "../lib/api";

const DEFAULTS = {
  company_name: "", address: "", cin: "", gstin: "", email: "", phone: "",
  website: "https://loansupportindia.com", support_contact: "", grievance_contact: "",
  registrations: "", whatsapp: "917980074801",
  tagline: "Let's Make Your Dreams Together",
  subtitle: "Compare and apply for suitable loan and insurance options from our authorised partners — quick, transparent and secure.",
  copyright_entity: "",
  grievance_officer_name: "", grievance_officer_email: "", grievance_officer_phone: "",
  grievance_officer_address: "", grievance_response_time: "",
};

const SettingsContext = createContext({ settings: DEFAULTS, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refresh = async () => {
    try {
      const data = await getSettings();
      const merged = { ...DEFAULTS, ...data };
      setSettings(merged);
      if (merged.whatsapp) runtime.whatsapp = merged.whatsapp;
    } catch {
      // keep defaults
    }
  };

  useEffect(() => { refresh(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
